export const testimonials = [
  {
    name: 'Sophie Laurent',
    handle: 'sophielaurent',
    content: 'Hipobuy Spreadsheet a complètement transformé ma façon de gérer les données de ma boutique en ligne. L\'automatisation est incroyablement intuitive et le gain de temps est considérable.',
  },
  {
    name: 'Marc Dubois',
    handle: 'marcdubois_pro',
    content: 'J\'ai essayé Google Sheets et Airtable pendant des années. Hipobuy Spreadsheet combine le meilleur des deux mondes : la simplicité et la puissance d\'automatisation.',
  },
  {
    name: 'Emma Petit',
    handle: 'emma_data',
    content: 'En tant que freelance, je cherchais un outil qui ne me prenne pas des heures à configurer. Hipobuy Spreadsheet est la solution parfaite. Mes clients adorent les rapports automatisés.',
  },
  {
    name: 'Thomas Bernard',
    handle: 'tbernard_mkg',
    content: 'Le support et la documentation sont excellents. J\'ai pu mettre en place un suivi e-commerce complet en moins d\'une journée. Vraiment recommandé pour les startups.',
  },
  {
    name: 'Camille Roux',
    handle: 'camilleroux',
    content: 'Interface propre, fonctionnalités puissantes, et surtout aucune courbe d\'apprentissage frustrante. Hipobuy Spreadsheet mérite vraiment sa place dans le top des outils 2026.',
  },
  {
    name: 'Lucas Moreau',
    handle: 'lmoreau_analytics',
    content: 'La fonction d\'analyse intelligente est un game-changer. Je peux maintenant croiser mes données marketing et ventes en quelques clics. C\'est exactement ce dont j\'avais besoin.',
  },
];